// 9fbef606107a605d69c0edbcd8029e5d 
const NAVIGATE_XHR_CONSTANTS = {
  NAVIGATE_XHR_STATE: 'NAVIGATE_XHR_STATE',
  SET_NAVIGATE_TOKEN: 'SET_NAVIGATE_TOKEN',
};

export default NAVIGATE_XHR_CONSTANTS;
